import React from 'react';
import { Container, Form, Button, Row, Col, Alert } from 'react-bootstrap';
import { FaXTwitter, FaLinkedin } from 'react-icons/fa6';

function Contact() {
  return (
    <div className="contact-page">
      <div className="overlay"></div>
      <Container className="py-5 position-relative page-content">
        <h2 className="text-center mb-5 page-title">اتصل بنا</h2>
        <Row>
          <Col md={6}>
            <div className="contact-card blurred-transparent shadow-lg text-bg-blur">
              <Form>
                <Form.Group controlId="formName" className="mb-3">
                  <Form.Label>الاسم</Form.Label>
                  <Form.Control type="text" placeholder="أدخل اسمك" className="blurred-input" />
                </Form.Group>
                <Form.Group controlId="formEmail" className="mb-3">
                  <Form.Label>البريد الإلكتروني</Form.Label>
                  <Form.Control type="email" placeholder="أدخل بريدك الإلكتروني" className="blurred-input" />
                </Form.Group>
                <Form.Group controlId="formPhone" className="mb-3">
                  <Form.Label>رقم الهاتف</Form.Label>
                  <Form.Control type="tel" placeholder="أدخل رقم هاتفك" className="blurred-input" />
                </Form.Group>
                <Form.Group controlId="formMessage" className="mb-3">
                  <Form.Label>رسالتك</Form.Label>
                  <Form.Control as="textarea" rows={4} placeholder="اكتب رسالتك هنا" className="blurred-input" />
                </Form.Group>
                <Button variant="outline-light" type="submit" className="w-100">
                  إرسال
                </Button>
              </Form>
              <Alert variant="success" className="mt-3 blurred-transparent">
                تم الإرسال بنجاح! (محاكاة)
              </Alert>
            </div>
          </Col>
          <Col md={6}>
            <div className="contact-info blurred-transparent shadow-lg text-bg-blur">
              <h4>معلومات التواصل</h4>
              <p className="text-gray">
                البريد الإلكتروني: <a href="mailto:Hamad1452@hotmail.com" className="text-white">Hamad1452@hotmail.com</a>
              </p>
              <p className="text-gray">
                <FaXTwitter className="me-2" /> X: <a href="https://x.com/HamadAlMuneef" className="text-white">@HamadAlMuneef</a>
              </p>
              <p className="text-gray">
                <FaLinkedin className="me-2" /> LinkedIn: <a href="https://linkedin.com/in/hamadalmuneef" className="text-white">Hamad Al Muneef</a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Contact;